import { IPublication as IPublicationSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/Publication';
import { IPublication } from '../../../types/reducers/publishTerms';
import { mapPeriod } from './mapPeriod';

export function mapPublication(publication?: IPublicationSchema | null): IPublication {
  const rawPeriod = publication?.period;
  const period = rawPeriod ? mapPeriod(rawPeriod) : null;

  return {
    period,
  };
}
